import { createAsyncThunk } from "@reduxjs/toolkit";
import { AddAIResponseApi, deleteChatSessionApi, editChatSessionTitleApi, getChatHistoryApi, getChatSessionHistoryApi, GetUsers, likeDislikeMessageApi } from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";
import { addMessage } from "./reducer"; 
import Cookies from 'js-cookie';

import * as url from "../../helpers/url_helper";
import { finalizeStreamingMessage, setStreamingStatus, updateStreamingMessage } from "./reducer";
import i18n from "../../i18n";

// In src/slices/thunks.js

const toBoolean = (value) => value === true || value === "true";

export const streamAIResponse = createAsyncThunk(
  "aiChat/streamAIResponse",
  async (payload, { getState, dispatch, rejectWithValue }) => {
    const { query, SessionID, IsLegal = true } = payload;
    
    const startTime = Date.now();
    let responseTimeMs = 0; 

    const tempAiMessageId = `ai-${Date.now()}`;
    let fullResponseText = "";
    let finalResponseData = null;

    try {

      // Step 1: Add placeholder (this is correct)
      dispatch(addMessage({
          ID: tempAiMessageId,
          SessionID: SessionID,
          Message: "",
          IsReceived: true,
          CreatedDate: new Date().toISOString(),
          isStreaming: true,
      }));

      const state = getState();
      const messages = state.AIChat.messages || [];

      // Step 2: Format chat history (this logic is ok, but let's refine it slightly to be safer)
      const chatHistory = [];
      // Iterate up to the message before the user's latest prompt and our placeholder
      const IsSendChatHistory = toBoolean(t("IsSendChatHistory"));
      if (IsSendChatHistory) {
        const relevantMessages = messages.slice(-10, -2); 
        for (let i = 0; i < relevantMessages.length; i++) {
            if (relevantMessages[i].IsReceived === false) { // User message
                if (i + 1 < relevantMessages.length && relevantMessages[i + 1].IsReceived === true) {
                    chatHistory.push({
                      user: relevantMessages[i].Message,
                      ai: relevantMessages[i + 1].Message,
                    });
                    i++; 
                }
            }
        }
      }

      // Step 3: Call SSE API
      const sseResponse = await fetch(IsLegal ? url.STREAMING_AI_RESPONSE : url.STREAMING_CASE_AI_RESPONSE, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'text/event-stream',
          'authorization': Cookies.get('authorization'),
          'DeviceID': Cookies.get('deviceId'),
        },
        body: JSON.stringify({
          query: query,
          chatData: chatHistory,
          // SessionID: SessionID,
          language: i18n.language,
          isFirstMessage: SessionID ? false : true,
        }),
      });

      if (!sseResponse.ok || !sseResponse.body) {
        const errorData = await sseResponse.json().catch(() => ({ message: sseResponse.statusText }));
        throw new Error(t(errorData.message) || t("StreamingConnectionFailed"));
      }

      const reader = sseResponse.body.getReader();
      const decoder = new TextDecoder("utf-8");

      // Step 4: Read and process the stream
      // while (true) {
      //     const { done, value } = await reader.read();
      //     if (done) {
      //       console.log("Stream finished.");
      //       break;
      //     }

      //     const chunk = decoder.decode(value, { stream: true });
      //     const eventLines = chunk.split('\n\n').filter(line => line.trim());

      //     for (const eventLine of eventLines) {
      //         const lines = eventLine.split('\n');
      //         let eventName = "";
      //         let eventData = "";
              
      //         for (const line of lines) {
      //             if (line.startsWith("event:")) {
      //                 eventName = line.substring(6).trim();
      //             } else if (line.startsWith("data:")) {
      //                 // FIX: Just assign the data, don't append with +=
      //                 // eventData = line.substring(5).trim();
      //                 eventData += line.substring(5) + "\n";
      //             }
      //         }

      //         if (eventData) {
      //                try {
      //                     let parsedData;

      //                     if (eventData) {

      //                         try {
      //                             parsedData = JSON.parse(eventData.toString());
      //                         } catch (e) {
      //                             console.warn(`Could not parse data for event [${eventName}], data=[${eventData}], error=${e.message}`);
      //                              let safeEventData = eventData.trim();

      //                               // Remove only control characters that break JSON
      //                               safeEventData = safeEventData.replace(/[\u0000-\u001F]+/g, "");

      //                               // Fix multiline chunks (SSE often delivers partial objects)
      //                               safeEventData = safeEventData.replace(/\r?\n/g, "\\n");

      //                               // Ensure brackets balance (if missing)
      //                               if (!safeEventData.endsWith("]")) {
      //                                 safeEventData += "]";
      //                               }
                                    
      //                               parsedData = JSON.parse(safeEventData);
      //                         }
      //                     }

      //                     //  Handle streaming text chunks
      //                    if (eventName === 'reason' && parsedData.message) {
      //                       dispatch(setStreamingStatus(parsedData.message));
      //                    }

      //                    if (eventName === 'response_part' && parsedData.message) {
      //                       fullResponseText += parsedData.message;
      //                       dispatch(updateStreamingMessage({ text: fullResponseText }));
      //                       responseTimeMs = Date.now() - startTime; // ✅ add this line
      //                    }

      //                    // Handle final answer events
      //                   //  if ((eventName === 'answer_done' || eventName === 'answer_complete') && parsedData.answer) {
      //                   //      fullResponseText = parsedData.answer;
                             
      //                   //      dispatch(updateStreamingMessage({ text: fullResponseText }));
      //                   //      responseTimeMs = Date.now() - startTime; // ✅ add this line
      //                   //      // No need to update status message here, the answer is appearing
      //                   //  }
      //                   //  // Handle the final "done" event
      //                   //  else if (eventName === 'done') {
      //                   //      // CALCULATE AND STORE RESPONSE TIME 
      //                   //      responseTimeMs = Date.now() - startTime;

      //                   //      finalResponseData = parsedData;
      //                   //      dispatch(setStreamingStatus("Finalizing..."));
      //                   //      break; // Exit the for-loop
      //                   //  }
      //                    // Handle "no_results" or other terminal events
      //                    else if (eventName === 'no_results' && parsedData.message) {
      //                        // CALCULATE AND STORE RESPONSE TIME 
      //                        responseTimeMs = Date.now() - startTime;

      //                        fullResponseText = parsedData.message;
      //                        dispatch(updateStreamingMessage({ text: fullResponseText }));
      //                        dispatch(setStreamingStatus("Finalizing..."));
      //                        // We might not get a 'done' event after this, so capture data
      //                        finalResponseData = parsedData; 
      //                        break; // Exit the for-loop
      //                    }

      //                    else if (eventName === 'error' && parsedData.message) {
      //                        // Handle error events
      //                        fullResponseText = parsedData.message; 
      //                        dispatch(setStreamingStatus(`Error: ${parsedData.message}`));
      //                    }
      //                    // Handle all intermediate status updates
      //                    else if (parsedData.message) {
      //                        dispatch(setStreamingStatus(parsedData.message));
      //                    } else {
      //                        dispatch(setStreamingStatus("Unknown event received"));
      //                    }

      //                } catch (e) {
      //                    console.warn(`Could not parse data for event [${eventName}], but continuing stream. Error: ${e.message}`);
      //                }
      //         }
      //     }
      //     // If we have a final response, break out of the while loop
      //     if (!responseTimeMs) {
      //         responseTimeMs = Date.now() - startTime;
      //     }
      //     if (finalResponseData) break; 
      // }

      // while (true) {
      //   const { done, value } = await reader.read();
      //   if (done) {
      //     console.log("Stream finished.");
      //     break;
      //   }
 
      //   const chunk = decoder.decode(value, { stream: true });
      //   const eventLines = chunk.split('\n\n').filter(line => line.trim());

      //   for (const eventLine of eventLines) {
      //     const lines = eventLine.split('\n');
          
      //     const dataLine = lines.find(line => line.startsWith("data:"));

      //     if (dataLine) {
      //       const eventData = dataLine.substring(5).trim();
      //       let parsedData;
      //       let eventName;

      //       try {
      //         parsedData = JSON.parse(eventData);
      //         eventName = parsedData.step; // The event name is now in the 'step' property
      //       } catch (e) {
      //         console.warn(`Could not parse JSON from data line, data=[${eventData}], error=${e.message}`);
      //         continue; // Skip to the next event line if JSON is invalid
      //       }

      //       // The logic below uses eventName and parsedData, which are now correctly set.
      //       // The original code had a nested try-catch which is now simplified.
      //       try {
      //         //  Handle streaming text chunks
      //           if (eventName === 'reason' && parsedData.message) {
      //             dispatch(setStreamingStatus(parsedData.message));
      //           }

      //           if (eventName === 'response_part' && parsedData.message) {
      //             fullResponseText += parsedData.message;
      //             dispatch(updateStreamingMessage({ text: fullResponseText }));
      //           }

      //           else if (eventName === 'done') {
      //             // CALCULATE AND STORE RESPONSE TIME
      //             // fullResponseText = parsedData.message;
                  
      //             // dispatch(updateStreamingMessage({ text: fullResponseText }));
      //             responseTimeMs = Date.now() - startTime;

      //             finalResponseData = parsedData;
      //             dispatch(setStreamingStatus("Finalizing..."));
      //             break; // Exit the for-loop
      //           }
      //           // Handle "no_results" or other terminal events
      //           else if (eventName === 'no_results' && parsedData.message) {
      //             // CALCULATE AND STORE RESPONSE TIME
      //             responseTimeMs = Date.now() - startTime;

      //             fullResponseText = parsedData.message;
      //             dispatch(updateStreamingMessage({ text: fullResponseText }));
      //             dispatch(setStreamingStatus("Finalizing..."));
      //             // We might not get a 'done' event after this, so capture data
      //             finalResponseData = parsedData;
      //             break; // Exit the for-loop
      //           }

      //           else if (eventName === 'error' && parsedData.message) {
      //             // Handle error events
      //             fullResponseText = parsedData.message;
      //             dispatch(setStreamingStatus(`Error: ${parsedData.message}`));
      //           }
      //           // Handle all intermediate status updates
      //           else if (eventName === 'init' && parsedData.message) { // Ignore 'init' for status
      //             dispatch(setStreamingStatus(parsedData.message));
      //           } else {
      //             //  dispatch(setStreamingStatus("Unknown event received"));
      //           }

      //       } catch (e) {
      //           console.warn(`Error processing event [${eventName}], but continuing stream. Error: ${e.message}`);
      //       }
      //     }
      //   }
      //   // If we have a final response, break out of the while loop
      //   if (!responseTimeMs) {
      //     responseTimeMs = Date.now() - startTime;
      //   }
      //   if (finalResponseData) break;
      // }

      let isStreamFinished = false;
      let link = null; 

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        const eventLines = chunk.split('\n\n').filter(line => line.trim());

        for (const eventLine of eventLines) {
          const lines = eventLine.split('\n');
          const dataLine = lines.find(line => line.startsWith("data:"));
          if (!dataLine) continue;

          const eventData = dataLine.substring(5).trim();
          let parsedData;
          let eventName;

          try {
            parsedData = JSON.parse(eventData);
            eventName = parsedData.step;
          } catch {
            continue;
          }

          // ---- ALL EVENTS ----
          if (eventName === 'reason' && parsedData.message) {
            dispatch(setStreamingStatus(parsedData.message));
          }

          else if (eventName === 'response_part' && parsedData.message) {
            fullResponseText += parsedData.message;
            dispatch(updateStreamingMessage({ text: fullResponseText }));
          }

          else if (eventName === 'done') {
            responseTimeMs = Date.now() - startTime;
            finalResponseData = parsedData;
            // isStreamFinished = true;      // <--- instead of break
          }

          else if (eventName === 'log_url') {
            link = parsedData.message;
            // isStreamFinished = true;      // <--- instead of break
          }

          else if (eventName === 'no_results') {
            responseTimeMs = Date.now() - startTime;
            fullResponseText = parsedData.message;
            dispatch(updateStreamingMessage({ text: fullResponseText }));
            finalResponseData = parsedData;
            isStreamFinished = true;      // <--- instead of break
          }

          else if (eventName === 'error') {
            dispatch(setStreamingStatus(`Error: ${parsedData.message}`));
          }

          else if (eventName === 'init') {
            dispatch(setStreamingStatus(parsedData.message));
          }
        }

        // Exit outer loop safely AFTER finishing the chunk
        if (isStreamFinished) break;
      }

      // --- Step 5: Finalize the streaming message ---
      const finalMessageFromStream = {
        ID: tempAiMessageId, // for now, keep the temp one
        SessionID: SessionID,
        Message: fullResponseText || "حدث خطأ، حاول مرة أخرى",
        IsReceived: true,
        IsLiked: 0,
        CreatedDate: new Date().toISOString(),
        ResponseTimeMs: responseTimeMs || 0, // Store the response time
        Link: link,
        isStreaming: false,
      };

      dispatch(finalizeStreamingMessage({ 
          tempId: tempAiMessageId, 
          finalMessage: finalMessageFromStream // Use the object we just created
      }));
      
      // --- Step 6: Save the complete response to the database ---
      const savePayload = {
        query: {
          userMessage: query,
          aiAnswer: fullResponseText || "حدث خطأ، حاول مرة أخرى",
          responseTimeMs: responseTimeMs,
          link: link
        },
        SessionID: SessionID,
        IsLegal: IsLegal
      };
      
      dispatch(AddAIResponse(savePayload))
      .then(dbResponse => {
        console.log("✅ DB save successful:", dbResponse);
      })
      .catch(dbError => {
        // Also handle errors in the background. A toast is appropriate here.
        console.error("💥 Error saving AI response to DB:", dbError);
        // toast.error("Failed to save chat history.");
      });    
     
      // UNCOMMENT THIS RETURN LATER
      // return dbResponse.data;
      return finalMessageFromStream;

    } catch (error) {
        console.error("💥 Error in streamAIResponse:", error);
        const errorMessage = error.message || "An error occurred during the AI response.";
        toast.error(t(errorMessage));
        
        dispatch(finalizeStreamingMessage({
            tempId: tempAiMessageId,
            finalMessage: {
                ID: tempAiMessageId,
                SessionID: SessionID,
                Message: `**Error:** ${errorMessage}`,
                IsReceived: true,
                CreatedDate: new Date().toISOString(),
                isError: true,
            }
        }));
        return rejectWithValue(errorMessage);
    }
  }
);

export const getChatSessionHistory = createAsyncThunk(
  "aiChat/getChatSessionHistory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getChatSessionHistoryApi(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching AI response");
    }
  }
);

export const getChatHistory = createAsyncThunk(
  "aiChat/getChatHistory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getChatHistoryApi(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching AI response");
    }
  }
);

// Like/Dislike Message API
export const likeDislikeMessage = createAsyncThunk(
  "aiChat/likeDislikeMessage",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await likeDislikeMessageApi(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching AI response");
    }
  }
);

// Edit Chat Session Title API
export const editChatSessionTitle = createAsyncThunk(
  "aiChat/editChatSessionTitle",
  async (payload, { rejectWithValue }) => {
    try {      
      const response = await editChatSessionTitleApi(payload);
      toast.success(t(response.data.message) || t("Chat session title updated successfully"));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || t("Error editing chat session title"));
    }
  }
);

// Delete Chat Session API
export const deleteChatSession = createAsyncThunk(
  "aiChat/deleteChatSession",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteChatSessionApi(payload);
      toast.success(t(response.data.message) || t("Chat session deleted successfully"));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || t("Error deleting chat session"));
    }
  }
);

// Add Chat Mesaage 
export const AddAIResponse = createAsyncThunk(
  "aiChat/addAIResponse",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AddAIResponseApi(payload);
      response.data.UserMessage = payload.query.userMessage;
      response.data.IsFirstMessage = payload.SessionID ? false : true;
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error adding AI response");
    }
  }
);

export const fetchAIChatUsers = createAsyncThunk(
  "aiChat/fetchAIChatUsers",
  async (users, thunkAPI) => {
    try {
      const response = await GetUsers(users);
      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);